import { ClipboardCheck } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
// Import the web manifest, never `../index.js`: the plugin entry pulls in the
// server graph (Fastify, node builtins), which Vite then externalizes and the
// SPA fails to boot.
import { workAssessmentWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  workAssessmentWeb,
  {
    WorkAssessmentTab: () => import('./WorkAssessmentTab'),
    WorkAssessmentTabPreview: () => import('./WorkAssessmentTabPreview'),
    StartAssessmentMentionProvider: () => import('./StartAssessmentMentionProvider'),
  },
  {
    icons: { ClipboardCheck },
  },
);
